<template>
  <div class="has-border-b filters white">
    <div class="filters-title">
      <v-icon color="gray-6">filter_list</v-icon>
      {{ $t('Common.filters') }}
    </div>

    <div class="filters-item filters-item--search filters-item--reset">
      <MenuItemPeriod
        :status="status"
        :time="false"
        @change="updateFilters"
        @changePeriod="changePeriod"
      />
    </div>

    <div class="filters-item filters-item__border">
      <MenuItemAutoComplete
        type="company"
        :status="status"
        @change="updateFilters"
      />
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce'
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import MenuItemPeriod from 'components/menuItemPeriod'
import MenuItemAutoComplete from 'components/reports/MenuItemAutoComplete'

export default {
  name: 'Filters',
  props: {
    status: {
      type: Number,
      default: STATUS_IS_LOADING
    }
  },
  components: {
    MenuItemPeriod,
    MenuItemAutoComplete
  },
  computed: {
    isLoading () {
      return this.status === STATUS_IS_LOADING
    },

    isSuccess () {
      return this.status === STATUS_SUCCESS
    },

    isFailed () {
      return this.status === STATUS_FAILED
    },

    searchIsLoading () {
      return this.isLoading && Boolean(this.filters.search)
    }
  },
  data () {
    return {
      namespace: 'Views.EmployeesPage',
      filters: {
        companyId: null,
        startDate: null,
        endDate: null
      }
    }
  },
  methods: {
    updateFilters (val) {
      this.filters = {
        ...this.filters,
        ...val
      }

      this.emitEvent()
    },

    changePeriod (period) {
      this.$emit('changePeriod', period)
    },

    emitEvent () {
      this.$emit('change', this.filters)
    },

    handleSearch: debounce(function () {
      this.emitEvent()
    }, 1000),

    handleChange (val) {
      this.filters.costCenterId = val
      this.emitEvent()
    }
  }
}
</script>
